export class modificheAmmesseProdotto {
	constructor() {
		this.itemID = null;
		this.pacchettoID = null;
		this.modificaNomiPartecipanti = null;
		this.modificaNumeroPartecipanti = null;
		this.modificaDataViaggio = null;
		this.modificaDurataViaggio = null;
		this.modificaDestinazione = null;
		this.modificaNazionalita = null;
		this.modificaImportoViaggio = null;
	}

	itemID: number | null;
	pacchettoID: number | null;
	modificaNomiPartecipanti: number | null;
	modificaNumeroPartecipanti: number | null;
	modificaDataViaggio: number | null;
	modificaDurataViaggio: number | null;
	modificaDestinazione: number | null;
	modificaNazionalita: number | null;
	modificaImportoViaggio: number | null;
}